export default __webpack_public_path__ + "static/media/GameOver.0242c96f.wav";